import React, { useEffect, useState } from 'react';
import ProzoDataGrid from '../../common/ProzoDataGrid';
import { Box, Typography, Chip, Button } from '@mui/material';
import { maskAddress, maskPhoneNumber, parseDateAndTime, shouldMaskDataPD } from '../../helpers/UtilityHelper';
import Loader from '../../common/Loader';
import { useGetNPRDataQuery } from '../../redux/commonRTK';
import { buildFilterConditions } from '../../helpers/UtilityHelper';
import { ActionLogModal } from '.';
import { getMerchant } from '../../helpers/ReduxHelpers';
import { useSelector } from 'react-redux';
import jwt_decode from 'jwt-decode';
import { getToken } from '../../helpers/ReduxHelpers';
import { primaryTextSx, secondaryTextSx, awbTextSx, cellStackSx, getStatusChipSx, getPaymentChipSx } from '../orders/list2/cellStyles';
import { FONT, SIZE } from '../../styles/foundation/typography';
import AwbLinkCell from '../../common/AwbLinkCell';


const InitiatedNdrData = (props) => {
    const { report } = useSelector(state => state);
    const { piiAccessAllow } = jwt_decode(getToken());
    const [initiatedNdrData, setInitiatedNDRData] = useState({});
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [logModal, setLogModal] = useState(false);
    const [logModalData, setLogModalData] = useState();
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''

    const exclude =
        "terminalStatus,shipmentDetail.cartonItems,invoiceNumber,shipmentType,returnInfo,labelUrl,dispatchMode,giftwrapCharge,transactionCharge,shippingCharge,isInsured,codType,riskType,appointmentDelivery,async,order_date,courierDetail.key,createdDate,actualPickUpTime,lastStatusUpdateTime,epd,edd,order_history,merchantPricing,merchant,orderManifest,invoiceUrl,courierPricingRTO,courierPricing,overriddenCourierAccountCode,actualCourierProviderName,isDiscrepancyRaised,discrepancyId,securityKey,sortCode,channelType,channelName,itemList,createdByUser,skipRule,modifiedByUser,rvp_reason,channel_name,customerDetail,cpErrorList,mongoLabelSignedUrlDetails,overriddenCourierRule,mongoInvoiceSignedUrlDetails,merchant,modifiedByUser,lastModifiedDate,courier";

    const filterConditions = buildFilterConditions(props.filters);
    const { data: initiatedData, isLoading, refetch } = useGetNPRDataQuery({
        andfilter: [
            {
                "field": "is_reverse",
                "operator": "eq",
                "value": true

            },
            {
                "field": "nprData.nprStatus",
                "operator": "in",
                "value": [
                    "INITIATED"
                ]
            },
            { field: "merchant.$id", operator: "eq", value: merchantId },
            ...filterConditions.andfilter,
        ],
        orfilter: [...filterConditions.orfilter],
        offset: page * sizePerPage,
        limit: sizePerPage,
        skipCount: true,
        controllerFilter: true,
        excludes: exclude,

    });
    useEffect(() => {
        setPage(0)
    }, [sizePerPage, props.filters])


    const columns = [
        {
            field: 'orderdetails', headerAlign: "left", hideSortIcons: true, headerName: 'Order Details', flex: 1, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>{row.reference}</Typography>
                        {row.shippingLabelId && row.reference !== row.shippingLabelId && (
                            <Typography sx={secondaryTextSx}>{row.shippingLabelId}</Typography>
                        )}
                        <Typography sx={secondaryTextSx}>
                            {(row.awbRegisteredDate) ? parseDateAndTime(row.awbRegisteredDate) : ""}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'courierDetails', headerAlign: "left", hideSortIcons: true, headerName: 'Courier Details', flex: 1, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <AwbLinkCell awb={row.awb_number} sx={awbTextSx} />
                        <Typography sx={secondaryTextSx}>{row?.courierDetail?.parent}</Typography>
                    </Box>
                )
            },
        },
        {
            field: 'status', headerAlign: "left", hideSortIcons: true, headerName: 'Status', flex: 0.8, minWidth: 130, renderCell: (params) => {
                const { row } = params;
                const orderStatus = row.orderStatus.replace(/_/g, ' ');
                return (
                    <Chip size="small" label={orderStatus} sx={getStatusChipSx(row.orderStatus)} />
                )
            },
        },
        {
            field: 'shipment', headerAlign: "left", hideSortIcons: true, headerName: 'Pickup Address', flex: 1.5, minWidth: 200, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>{row.pickup_details?.from_name}</Typography>
                        <Typography sx={secondaryTextSx}>
                            {shouldMaskDataPD(report, row, piiAccessAllow)
                                ? maskPhoneNumber(row.pickup_details?.from_phone_number)
                                : row.pickup_details?.from_phone_number}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            {shouldMaskDataPD(report, row, piiAccessAllow)
                                ? maskAddress(
                                    row.pickup_details?.from_address,
                                    row.pickup_details?.from_city,
                                    row.pickup_details?.from_state,
                                    row.pickup_details?.from_pincode
                                )
                                : (
                                    <>
                                        {row.pickup_details?.from_address}
                                        {row.pickup_details?.from_city}
                                        {row.pickup_details?.from_state}
                                        {row.pickup_details?.from_pincode}
                                    </>
                                )}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'nprCpStatusDescription', headerAlign: "left", hideSortIcons: true, headerName: 'NPR Description', flex: 1, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={secondaryTextSx}>
                            {(row.nprData && row.nprData.nprCpStatusDescription)
                                ? row.nprData.nprCpStatusDescription
                                : (row.nprData && row.nprData.remark)
                                    ? row.nprData.remark
                                    : "-"}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            {(row.nprData && row.nprData.nprReportedDate) ? parseDateAndTime(row.nprData.nprReportedDate, true) : ""}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'ofPCount', headerAlign: "left", hideSortIcons: true, headerName: 'OFP Attempt Count', flex: 0.5, minWidth: 120, renderCell: (params) => {
                const { row } = params;
                const count = (row.nprData && row.nprData.ofPCount) ? row.nprData.ofPCount : 0;
                return (
                    <Typography sx={secondaryTextSx}>
                        {count} attempt(s)
                    </Typography>
                )
            },
        },
        {
            field: 'actionLog', headerAlign: "left", hideSortIcons: true, headerName: 'Action Log', flex: 0.7, minWidth: 100, renderCell: (params) => {
                const { row } = params;
                return (
                    <Button
                        sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0 }}
                        onClick={() => {
                            setLogModalData(row.nprData?.actionUpdateLog);
                            setLogModal(true);
                        }}
                    >
                        View Log
                    </Button>
                )
            },
        },
        {
            field: 'paymentDetails', headerAlign: "left", hideSortIcons: true, headerName: 'Payment Details', flex: 1, minWidth: 140, renderCell: (params) => {
                const { row } = params;
                const paymentMode = row.payment_mode ? row.payment_mode : '';
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>
                            {(row.invoice_value) ? "Rs. " + row.invoice_value : ""}
                        </Typography>
                        <Chip size="small" label={paymentMode} sx={getPaymentChipSx(paymentMode)} />
                    </Box>
                )
            },
        },
    ];

    useEffect(() => {
        if (initiatedData) {
            setInitiatedNDRData(initiatedData);
        }
    }, [initiatedData]);

    useEffect(() => {
        refetch();
    }, [page, sizePerPage, props.filters, refetch]);


    return (
        <>
            {(isLoading) && <Loader />}
            <ActionLogModal data={logModalData} logModal={logModal} setLogModal={setLogModal} />
            <ProzoDataGrid columns={columns}
                autoHeight={true}
                rows={(initiatedNdrData.data && initiatedNdrData.data.length > 0) ? initiatedNdrData.data : []}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                hideFooterPagination={false}
                filterMode={"server"}
                rowCount={Number.MAX_VALUE}
                getRowId={(row) => row.id} />
        </>
    );
};

export default InitiatedNdrData
